import React, { ReactElement, useState } from 'react';
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Programme, Weighting } from '../../../../../types/entity.types';

import { getClassNames } from '../../../../../utils/util';
import { UPCOMING } from '../../../../../utils/constants';

import NumberPicker from '../../../../common/input/number-picker/NumberPicker';

import './accountability-weightings.scss';

type Props = {
  programme: Programme;
  status: string;
  weightings?: Weighting;
  updateWeighting: (key: keyof Weighting, value: number) => void;
};

const AccountabilityWeightings = ({ programme, status, weightings, updateWeighting }: Props): ReactElement => {
  const [open, setOpen] = useState(true);

  const clampNumber = (value: number): number => {
    if (value > 100) {
      value = 100;
    } else if (value < 1) {
      value = 0;
    }

    return value;
  };

  return (
    <div
      className={getClassNames('accountability__section', {
        closed: !open
      })}
      data-testid="accountability-weightings"
    >
      <div className="accountability__section__header">
        <p>WEIGHTINGS</p>
        {!open && (
          <FontAwesomeIcon
            className="accountability__section__open-icon"
            icon={faPlus}
            onClick={(): void => setOpen(true)}
            data-testid="open-icon"
          />
        )}
        {open && (
          <FontAwesomeIcon
            className="accountability__section__close-icon"
            icon={faMinus}
            onClick={(): void => setOpen(false)}
            data-testid="close-icon"
          />
        )}
      </div>
      {open && (
        <div className="accountability-weightings">
          <div className="accountability-weightings__input">
            <label>Weight</label>
            <NumberPicker
              value={weightings?.weight ?? ''}
              onChange={(value: number | string): void => updateWeighting('weight', clampNumber(value as number))}
              disabled={status !== UPCOMING}
              hideArrows
            />
            <p>%</p>
          </div>
          <div className="accountability-weightings__input">
            <label>cm's</label>
            <NumberPicker
              value={weightings?.cm ?? ''}
              onChange={(value: number | string): void => updateWeighting('cm', clampNumber(value as number))}
              disabled={status !== UPCOMING}
              hideArrows
            />
            <p>%</p>
          </div>
          <div className="accountability-weightings__input">
            <label>Steps</label>
            <NumberPicker
              value={weightings?.steps ?? ''}
              onChange={(value: number | string): void => updateWeighting('steps', clampNumber(value as number))}
              disabled={status !== UPCOMING}
              hideArrows
            />
            <p>%</p>
          </div>
          <div className="accountability-weightings__input">
            <label>Objectives</label>
            <NumberPicker
              value={weightings?.objectives ?? ''}
              onChange={(value: number | string): void => updateWeighting('objectives', clampNumber(value as number))}
              disabled={status !== UPCOMING}
              hideArrows
            />
            <p>%</p>
          </div>
          {programme?.charityWork && (
            <div className="accountability-weightings__input">
              <label>Charity</label>
              <NumberPicker
                value={weightings?.charity ?? ''}
                onChange={(value: number | string): void => updateWeighting('charity', clampNumber(value as number))}
                disabled={status !== UPCOMING}
                hideArrows
              />
              <p>%</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AccountabilityWeightings;
